import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import AddtionalSalesSummaryView from './AddtionalSalesSummaryView';

const AdditionalSalesSummary = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Additional Sales Summary Report" mainTitle="Additional Sales Summary Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <AddtionalSalesSummaryView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default AdditionalSalesSummary